export const enResources = {
  translation: {
    common: {
      languages: {
        uz: "O'zbek (Latin)",
        "uz-cyrl": "O'zbek (Cyrillic)",
        ru: "Russian",
        en: "English",
      },
      languageShort: {
        uz: "UZ",
        "uz-cyrl": "UZ-K",
        ru: "RU",
        en: "EN",
      },
      actions: {
        goHome: "Go back home",
        tryAgain: "Try again",
        backToFiles: "Back to XLS files",
        backToImports: "Back to imports",
        refresh: "Refresh",
        chooseFile: "Choose file",
        changeFile: "Change file",
        startImport: "Start import",
        inspect: "Inspect",
        openItems: "Open items",
        login: "Login",
        register: "Register",
        forgotPassword: "Forgot password?",
        backToLogin: "Back to login",
        restoreDefaults: "Restore Defaults",
        remove: "Remove",
        more: "More actions",
        cancel: "Cancel",
        back: "Back",
        clear: "Clear",
      },
      copy: {
        copy: "Copy",
        copyLabeled: "Copy {{label}}",
        copied: "Copied to clipboard",
        copiedLabeled: "{{label}} copied",
      },
      rateLimit: {
        message: "Too many requests. Wait {{time}}.",
        seconds: "{{count}}s",
        minutes_one: "{{count}} minute",
        minutes_other: "{{count}} minutes",
      },
      account: {
        account: "Account",
        billing: "Billing",
        notifications: "Notifications",
        myOrganization: "My Organization",
        logOut: "Log out",
        authenticated: "authenticated",
        user: "user",
        organization: "org {{id}}",
      },
      states: {
        searching: "Searching...",
        loading: "Loading...",
        noData: "No data",
        latest: "Latest",
        none: "None",
        processing: "processing",
        queued: "queued",
        finished: "Finished",
      },
      currency: {
        som: "so'm",
      },
      table: {
        firstPage: "First page",
        prevPage: "Previous page",
        nextPage: "Next page",
        lastPage: "Last page",
      },
      routeError: {
        title: "Something went wrong",
        description: "We couldn't load this page. Please try again.",
        retry: "Try again",
      },
    },
    navigation: {
      new: "New",
      groups: {
        main: "Main",
        organizations: "Organizations",
        pricing: "Pricing",
        authentication: "Authentication",
      },
      items: {
        medicines: "Medicines",
        wholesaleOffers: "Wholesale Offers",
        priceAnalysis: "Price Analysis",
        priceTrends: "Price Trends",
        organizations: "Organizations",
        organizationRatings: "Organization Ratings",
        organizationImport: "Import",
        organizationEdit: "My Organization",
        vendors: "Manufacturers",
        certifiedMedicines: "Certificates",
        referentPrices: "Referent Prices",
        orders: "Orders",
        cart: "Cart",
        default: "Default",
        crm: "CRM",
        analytics: "Analytics",
        pharmacy: "Pharmacy",
        ecommerce: "E-Commerce",
        academy: "Academy",
        logistics: "Logistics",
        loginV1: "Login v1",
        loginV2: "Login v2",
        registerV1: "Register v1",
        registerV2: "Register v2",
      },
    },
    layout: {
      search: {
        button: "Search",
        placeholder: "Search dashboards, users, and more…",
        empty: "No results found.",
        quickCreate: "Quick Create",
        inbox: "Inbox",
        shortcut: "Search",
        soon: "Soon",
      },
      preferences: {
        title: "Preferences",
        description: "Customize your dashboard layout preferences.",
        storageNote:
          "Preferences use cookies by default. You can switch between cookies, localStorage, or no storage in code.",
        themePreset: "Theme Preset",
        presetPlaceholder: "Preset",
        fonts: "Fonts",
        fontPlaceholder: "Select font",
        themeMode: "Theme Mode",
        pageLayout: "Page Layout",
        navbarBehavior: "Navbar Behavior",
        sidebarStyle: "Sidebar Style",
        sidebarCollapseMode: "Sidebar Collapse Mode",
        modes: {
          light: "Light",
          dark: "Dark",
          system: "System",
        },
        layoutOptions: {
          centered: "Centered",
          fullWidth: "Full Width",
        },
        navbarOptions: {
          sticky: "Sticky",
          scroll: "Scroll",
        },
        sidebarOptions: {
          inset: "Inset",
          sidebar: "Sidebar",
          floating: "Floating",
        },
        collapseOptions: {
          icon: "Icon",
          offcanvas: "OffCanvas",
        },
      },
      medicineSearch: {
        button: "Medicine search",
        title: "Find a medicine",
        recent: "Recent searches",
      },
      languageSelector: {
        placeholder: "Language",
        ariaLabel: "Application language",
      },
      themeSwitcher: {
        ariaLabel: "Current theme: {{theme}}. Click to cycle themes",
      },
    },
    auth: {
      checkingSession: "Checking your session...",
      login: {
        title: "Login to your account",
        description: "Please enter your details to login.",
        phone: "Phone number",
        password: "Password",
        submit: "Login",
        submitting: "Logging in...",
        success: "Logged in successfully.",
        invalidPhone: "Phone must match 998XXXXXXXXX.",
        passwordRequired: "Password is required.",
        failed: "Unable to login right now.",
        modes: {
          password: "Password",
          otp: "Telegram",
          switchToPassword: "Sign in with password",
          switchToOtp: "Sign in with Telegram",
        },
        noAccount: "No account?",
        errors: {
          invalidCredentials: "Invalid phone or password.",
          tooManyAttempts: "Too many attempts. Try again in 15 minutes.",
          userNotFound: "This phone is not registered. Please sign up first.",
          tooManyOtp: "Too many requests. Please try again later.",
          notTelegram: "This number has no Telegram. Sign in with password.",
          sendFailed: "Couldn't send the code. Please try again later.",
          codeInvalid: "Invalid verification code. Try again.",
          codeExpired: "Code expired or attempts exhausted. Please start over.",
          verifyFailed: "Couldn't verify the code. Please try again.",
          network: "Check your internet connection.",
          generic: "Unexpected error. Please try again.",
        },
        otp: {
          phaseATitle: "Sign in with Telegram",
          phaseADescription: 'Enter your phone — we\'ll send a code to your Telegram "Verification Codes" chat.',
          phaseBTitle: "Enter the code",
          phaseBDescription: 'We sent a code to your Telegram "Verification Codes" chat.',
          sendCode: "Send code",
          sending: "Sending...",
          codeLabel: "Verification code",
          verify: "Verify",
          verifying: "Verifying...",
          resend: "Resend code",
          resendIn: "Resend in {{time}}",
          otherPhone: "Use another phone",
          sentTo: "Sent to {{phone}}",
        },
      },
      register: {
        title: "Create your account",
        description: "Please enter your details to register.",
        otpDescription: "We sent a 6-digit verification code via SMS.",
        language: "Language",
        languagePlaceholder: "Choose language",
        languageRequired: "Please choose a language.",
        firstName: "First name",
        lastName: "Last name",
        phone: "Phone number",
        password: "Password",
        passwordConfirm: "Confirm password",
        showPassword: "Show password",
        hidePassword: "Hide password",
        submit: "Sign up",
        submitting: "Submitting...",
        success: "Registration successful.",
        failed: "Unable to register right now.",
        alreadyHaveAccount: "Already have an account?",
        firstNameRequired: "First name is required.",
        firstNameMax: "First name must be at most 100 characters.",
        lastNameRequired: "Last name is required.",
        lastNameMax: "Last name must be at most 100 characters.",
        invalidPhone: "Phone must match 998XXXXXXXXX.",
        passwordRequired: "Password is required.",
        passwordMin: "Password must be at least 8 characters.",
        passwordConfirmRequired: "Please confirm your password.",
        passwordsMismatch: "Passwords do not match.",
        organizationInn: "Organization INN",
        organizationInnHint: "Enter the 9-digit INN to autofill organization details.",
        organizationInnInvalid: "INN must be exactly 9 digits.",
        organizationInnLookupLoading: "Looking up organization…",
        organizationInnLookupNotFound: "No organization found for this INN.",
        organizationInnLookupFailed: "Couldn't fetch organization details. Please enter them manually.",
        organizationName: "Organization name",
        organizationNameRequired: "Organization name is required.",
        organizationNameMax: "Organization name must be at most 255 characters.",
        organizationAddress: "Address",
        organizationAddressMax: "Address must be at most 500 characters.",
        organizationSection: "Organization",
        modeCreateTitle: "Create new organization",
        modeCreateDescription: "Set up your own pharmacy or warehouse.",
        modeJoinTitle: "Join existing organization",
        modeJoinDescription: "Send a request to an existing organization owner.",
        modeJoinHint: "After signing up, pick an organization to send a join request.",
        errors: {
          alreadyRegistered: "This phone is already registered.",
          loginLink: "Sign in",
          tooManyRequests: "Too many requests. Please try again later.",
          sendFailed: "Couldn't send the code. Please try again later.",
          generic: "Unexpected error. Please try again.",
          network: "Check your internet connection.",
          organizationFailed: "Account created, but organization creation failed. You can create it later.",
        },
      },
      forgotPassword: {
        title: "Reset password",
        description: "Enter your phone, confirm the code, then set a new password.",
        otpDescription: "We sent a 6-digit verification code via SMS.",
        phone: "Phone number",
        newPassword: "New password",
        passwordConfirm: "Confirm password",
        submit: "Send code",
        submitting: "Sending...",
        resetSubmit: "Reset password",
        success: "Password updated. You can sign in with your new password.",
        invalidPhone: "Phone must match 998XXXXXXXXX.",
        passwordRequired: "Password is required.",
        passwordMin: "Password must be at least 8 characters.",
        passwordConfirmRequired: "Please confirm your password.",
        passwordsMismatch: "Passwords do not match.",
        errors: {
          userNotFound: "This phone is not registered.",
          tooManyRequests: "Too many requests. Please try again later.",
          sendFailed: "Couldn't send the code. Please try again later.",
          codeExpired: "Code expired or attempts exhausted. Please start over.",
          codeInvalid: "Invalid verification code. Try again.",
          network: "Check your internet connection.",
          generic: "Unexpected error. Please try again.",
        },
      },
    },
    landing: {
      nav: {
        platform: "Platform",
        data: "Live Data",
        activity: "Activity",
        login: "Sign In",
        getStarted: "Get Started",
      },
      hero: {
        badge: "Pharmaceutical market intelligence for Uzbekistan",
        title1: "Know the real price",
        title2: "before you buy",
        subtitle:
          "PharmaLogic collects and analyzes medicine prices from wholesalers across Uzbekistan every day — so pharmacies can compare offers, spot trends, and purchase smarter.",
        cta: "Open Dashboard",
        ctaSecondary: "See How It Works",
        trustRegions: "Regions covered",
        trustUpdates: "Data updates",
        trustFree: "Free access",
      },
      problem: {
        badge: "The challenge",
        title: "How pharmacies buy medicines today",
        before: "Without PharmaLogic",
        after: "With PharmaLogic",
        pain1: "Manually checking dozens of supplier price lists in Telegram every morning",
        pain2: "Comparing prices across Excel files with no standard format",
        pain3: "Missing better deals because there's no single view of the market",
        pain4: "No way to see if a price went up or down over the last weeks",
        gain1: "All supplier prices collected and organized automatically every day",
        gain2: "One search to compare every offer across all wholesalers instantly",
        gain3: "Price trends and history so you know if now is the right time to buy",
        gain4: "Alerts on promotions and expiring offers you might miss otherwise",
      },
      showcase: {
        badge: "The Product",
        title: "Built for pharmacy purchasing teams",
        subtitle:
          "A clean dashboard where you search medicines, compare wholesale prices, track trends, and build orders — all from one place.",
      },
      howItWorks: {
        badge: "How it works",
        title: "From raw price lists to smart decisions",
        subtitle: "We do the hard part so you can focus on what matters — getting the best prices for your pharmacy.",
        step1Title: "We collect the data",
        step1Desc:
          "Every day our system pulls price lists from supplier Telegram channels and processes Excel files automatically. No manual work needed.",
        step2Title: "We clean and organize",
        step2Desc:
          "Raw data gets matched to our medicine database, prices are validated, outliers flagged, and daily aggregates computed.",
        step3Title: "You make better decisions",
        step3Desc:
          "Search any medicine, see all offers sorted by price, check the trend, and add to your order — in seconds, not hours.",
      },
      coverage: {
        badge: "Nationwide reach",
        title: "Covering every corner of Uzbekistan",
        subtitle:
          "Data flows in from all 13 regions. Whether you're a pharmacy in Tashkent or Nukus — you see the same complete market picture.",
        pharmacies: "Pharmacies tracked",
        wholesalers: "Wholesalers",
        regions: "Regions",
        vendors: "Manufacturers",
      },
      stats: {
        badge: "Live Market Data",
        title1: "The market in numbers",
        title2: "updated daily",
        subtitle:
          "We track every medicine, wholesale offer, and price change across the country — here is what the data looks like right now.",
        medicines: "Medicines in database",
        vendors: "Manufacturers",
        pharmacies: "Retail pharmacies",
        wholesalers: "Approved wholesalers",
        offers: "Active wholesale offers",
        coverage: "Wholesale price coverage",
      },
      features: {
        badge: "What PharmaLogic solves",
        title1: "Pharmacy purchasing",
        title2: "without the guesswork",
        priceCompare: "Price comparison",
        priceCompareDesc:
          "See wholesale prices from every supplier side by side. Find who has the best offer for each medicine — instantly.",
        trends: "Price trend tracking",
        trendsDesc:
          "Daily price aggregates show you when prices rise, fall, or stay flat. Spot seasonal patterns and anomalies before they cost you.",
        coverage: "Nationwide coverage",
        coverageDesc:
          "Data from all 13 regions of Uzbekistan. Retail pharmacies, wholesale distributors, and manufacturers — all in one place.",
        realtime: "Daily data updates",
        realtimeDesc:
          "Price lists are collected from supplier Telegram channels and processed automatically every day. Always current, never stale.",
        search: "Smart medicine search",
        searchDesc:
          "Find any medicine by trade name, international name, dosage form, or strength. Autocomplete makes it fast.",
        wholesale: "Wholesale offer analysis",
        wholesaleDesc:
          "Compare offers including payment terms, expiry dates, and promotions. Filter by region, supplier, or price range.",
        analytics: "Market analytics",
        analyticsDesc:
          "Dashboard-level KPIs: market size, coverage rates, supplier activity, and more. Understand the big picture.",
        orders: "Order management",
        ordersDesc:
          "Build orders from the best wholesale offers, track fulfillment, and manage your purchasing workflow in one place.",
      },
      activity: {
        badge: "30-Day Market Pulse",
        title: "Market activity",
        subtitle:
          "Daily wholesale activity across all tracked suppliers — offers published, suppliers active, and promotions running.",
        offers: "Wholesale Offers",
        suppliers: "Supplier Updates",
        wholesalers: "Active Wholesalers",
        promos: "Promotions",
        unavailableTitle: "Market data is temporarily unavailable",
        unavailableDescription: "Activity trends will appear here once analytics data is available again.",
      },
      cta: {
        title1: "Start making",
        title2: "smarter purchases",
        subtitle: "Free access to medicine prices, wholesale offers, and market analytics across Uzbekistan.",
        login: "Sign In",
        register: "Create Account",
      },
      footer: {
        rights: "All rights reserved.",
        tagline: "Smart analytics platform for the Uzbekistan pharmaceutical market.",
        quickLinks: "Quick Links",
        contact: "Contact",
        poweredBy: "Powered by",
        privacy: "Privacy Policy",
        accountDeletion: "Delete account",
      },
      privacy: {
        title: "Privacy Policy",
        lastUpdated: "Last updated: April 27, 2026",
        backHome: "Back to home",
        intro:
          'PharmaLogic ("we", "us", "our") respects your privacy. This Privacy Policy explains how we collect, use, and protect your personal information. By using our platform, you agree to the terms of this policy.',
        s1Title: "1. Information We Collect",
        s1Body:
          "Account information: phone number, name, organization name, and email address. Usage data: search history, viewed medicines, cart contents, and orders. Device data: browser type, IP address, and locally cached account/session state. Wholesale supplier data is collected from public Telegram channels and is treated as business information, not personal data.",
        s2Title: "2. How We Use Information",
        s2Body:
          "To provide and improve our analytics services, authenticate users and protect accounts, send notifications about price changes, promotions, and expiry, respond to user inquiries, and comply with legal obligations.",
        s3Title: "3. Sharing of Information",
        s3Body:
          "We never sell your personal data. We may share data with our service providers (e.g. hosting providers and SMS gateways for OTP delivery). We may disclose information when required by law or in response to a valid request from law enforcement.",
        s4Title: "4. Cookies and Local Storage",
        s4Body:
          "We use an HttpOnly authentication cookie for your session. Browser localStorage stores UI preferences and non-sensitive cached account state. We do not use third-party advertising or tracking cookies.",
        s5Title: "5. Data Security",
        s5Body:
          "All data is transmitted over an encrypted channel via HTTPS. Authentication uses secure cookies and idempotency keys for write operations. We conduct regular security reviews and restrict system access.",
        s6Title: "6. Your Rights",
        s6Body:
          "You have the right to access, view, and correct your data via your account settings. You may delete your account and all associated data at any time. You may also withdraw your consent to data processing.",
        s7Title: "7. Data Retention",
        s7Body:
          "Account data is retained until you request its deletion. Anonymous aggregated analytics may be retained in a non-identifiable form to improve the platform.",
        s8Title: "8. Children's Privacy",
        s8Body:
          "PharmaLogic is a B2B platform for pharmacies and wholesalers. The service is not directed at individuals under 18, and we do not knowingly collect data from children.",
        s9Title: "9. Changes to This Policy",
        s9Body:
          "We may update this Privacy Policy from time to time. The latest revision date is shown above. We will notify you of material changes by email or through the platform. Continued use of the service after changes constitutes acceptance of the updated policy.",
        s10Title: "10. Contact Us",
        s10Body: "For privacy-related questions or requests, please contact us:",
      },
      privacyMobile: {
        title: "Privacy Policy",
        lastUpdated: "Last updated: May 29, 2026",
        backHome: "Back to home",
        intro:
          'This Privacy Policy describes how the PharmaLogic mobile app ("we", "us", "our") collects, uses, and protects your information. By installing and using the app, you agree to this policy.',
        s1Title: "1. Information We Collect",
        s1Body:
          "Account information you provide when you register: first and last name, phone number, and password. We verify your phone number by a one-time SMS code (OTP). Usage data: medicine searches, viewed medicines, saved favorites and bookmarks, and cart contents. Device data: device model, operating system version, app version, language, and a push notification token.",
        s2Title: "2. Location Data",
        s2Body:
          "With your permission, the app accesses your approximate or precise location to find nearby pharmacies and show the distance to them. Location is processed only while you use the map and search features and is never used for advertising. You can grant or revoke location access at any time in your device settings; the app remains usable without it.",
        s3Title: "3. How We Use Information",
        s3Body:
          "To show medicine availability and nearby pharmacies, authenticate you and keep your account secure, save your favorites, bookmarks and cart, send notifications you have enabled, respond to your reports and inquiries, and improve the app.",
        s4Title: "4. Push Notifications",
        s4Body:
          "If you enable notifications, we register a device push token to send you relevant updates. Push messages are delivered through the Expo push notification service and the Apple and Google notification systems. You can disable notifications at any time in your device settings.",
        s5Title: "5. Reporting Pharmacy Issues",
        s5Body:
          "When you report an issue with a pharmacy or listing, we collect the selected reason, the related pharmacy and medicine identifiers, your optional comment, and an optional contact phone number so we can follow up. This information is used only to review and correct the reported listing.",
        s6Title: "6. Sharing of Information",
        s6Body:
          "We never sell your personal data. We may share data with service providers acting on our behalf, such as hosting providers, an SMS gateway for OTP delivery, and the push notification service. We may disclose information when required by law or a valid request from authorities.",
        s7Title: "7. Third-Party Map and Navigation Services",
        s7Body:
          "The app shows an in-app map using Google Maps. When you choose to get directions or call a pharmacy, the app opens an external app you select — such as Google Maps, Yandex Maps, Yandex Navigator, Yandex Go, or 2GIS, or your phone dialer. Those apps are governed by their own privacy policies.",
        s8Title: "8. Data Security",
        s8Body:
          "All data is transmitted over encrypted HTTPS connections. Authentication tokens are stored in the secure storage provided by your device (iOS Keychain / Android Keystore). We restrict internal access and review our systems regularly.",
        s9Title: "9. Your Rights",
        s9Body:
          "You can view and correct your account details in the app. You may delete your account and all associated data at any time, and you may withdraw permissions such as location and notifications through your device settings.",
        s10Title: "10. Data Retention",
        s10Body:
          "We retain your account data until you request its deletion. Locally stored data such as search history can be cleared from within the app. Anonymous, aggregated statistics may be retained in a non-identifiable form to improve the app.",
        s11Title: "11. Children's Privacy",
        s11Body:
          "The app is intended for a general audience seeking pharmacy and medicine information. It is not directed at children under 13, and we do not knowingly collect personal data from them.",
        s12Title: "12. Contact Us",
        s12Body: "For privacy-related questions or requests, please contact us:",
      },
      accountDeletion: {
        backHome: "Back to home",
        title: "Delete account",
        intro:
          "You can request deletion of your PharmaLogic mobile app account and all its associated data on this page. Enter your phone number — we'll verify it with an SMS code.",
        whatDeletedTitle: "What data will be deleted",
        deletedItem1: "Profile data: first name, last name and phone number",
        deletedItem2: "Order and search history",
        deletedItem3: "Saved favorites and bookmarks",
        deletedItem4: "Notification settings and push tokens",
        retainedNote:
          "Some records required by law (for example, transaction documents) may be kept in an anonymized form.",
        graceNote:
          "After the request is confirmed, the account will be permanently deleted within 3 days. You can cancel the deletion during this period.",
        phoneLabel: "Phone number",
        invalidPhone: "Enter a valid phone number",
        confirmLabel: "I confirm the deletion of my account and all my data",
        confirmRequired: "Please confirm to continue",
        sendCode: "Send code",
        sending: "Sending...",
        verifyTitle: "Verification code",
        codeSentTo: "A verification code was sent to {{phone}}",
        verify: "Confirm",
        verifying: "Verifying...",
        changePhone: "Change phone number",
        resend: "Resend",
        resendIn: "Resend ({{time}})",
        scheduledTitle: "Deletion scheduled",
        scheduledMessage: "Account {{phone}} will be permanently deleted on {{date}}.",
        scheduledHint: "If you change your mind, you can cancel the deletion before this date.",
        cancelButton: "Cancel deletion",
        cancelling: "Cancelling...",
        cancelledTitle: "Deletion cancelled",
        cancelledMessage: "Your account has been kept. No data was deleted.",
      },
    },
    feedback: {
      pageNotFound: {
        title: "Page not found.",
        description: "The page you are looking for could not be found.",
      },
      dashboardComingSoon: {
        description: "This section will be added in future updates.",
      },
      pageInDevelopment: {
        description: "This page is under development and will be available in future updates.",
      },
      unauthorized: {
        title: "Unauthorized Access",
        description:
          "You do not have permission to view the requested content. Please contact the site administrator if you believe this is an error.",
      },
      serverError: {
        title: "Something went wrong.",
        description: "An unexpected error occurred. Please try again or go back home.",
      },
      externalLanding: "Coming Soon",
      tour: {
        next: "Next",
        prev: "Back",
        done: "Got it",
        skip: "Skip",
        restart: "Restart page tour",
        progress: "{{current}} / {{total}}",
        wholesaleOffers: {
          toolbar: {
            title: "Filter and search",
            description:
              "Pick a medicine, organization or region and tweak filters here. Active filters update results instantly.",
          },
          results: {
            title: "Wholesale offers",
            description:
              "Every matching offer lands here. Click a row for price history; toggle columns from the toolbar.",
          },
        },
        certificates: {
          search: {
            title: "Search certificates",
            description: "Type a product name, INN, or vendor to narrow the list. A few characters are enough.",
          },
          filters: {
            title: "Refine results",
            description: "Filter by year, country, certifying body, or shelf-life date. Combine them to drill down.",
          },
          results: {
            title: "Certified medicines",
            description: "Open any row to see full certificate details, including issue date and remaining shelf life.",
          },
        },
        organizations: {
          list: {
            title: "Organizations directory",
            description: "Browse and search every registered organization. Pick one to load its full profile.",
          },
          detail: {
            title: "Organization details",
            description:
              "Selected organization's info and uploaded price lists appear here. Filter files by region or payment terms.",
          },
        },
        priceAnalysis: {
          search: {
            title: "Pick medicines to compare",
            description:
              "Search and add medicines you want to track over time. Picked medicines stack in the compare table below.",
          },
          compare: {
            title: "Compare table",
            description:
              "All compared medicines and their current prices live here. Click a row to focus on that medicine.",
          },
          trend: {
            title: "Price trends",
            description:
              "Hover the chart to inspect price points by date. Switch between wholesale, retail, and referent tabs.",
          },
        },
        priceTrends: {
          title: "Price trends",
          description: "Compare medicine price movements across the selected time window.",
          window: "Time window",
          windows: { "7": "7 days", "30": "30 days", "90": "90 days" },
          coverage: "Coverage: {{start}} – {{end}}",
          coverageUnavailable: "Coverage unavailable",
          sections: {
            consistent: "Consistent price movements",
            increases: "Largest price increases",
            decreases: "Largest price decreases",
            volatile: "Most volatile prices",
          },
          table: {
            medicine: "Medicine",
            coverage: "Coverage",
            medianPrice: "Median price",
            from: "was",
            metric: "Metric",
          },
          direction: { rising: "Rising", falling: "Falling" },
          empty: {
            title: "No medicines qualify for this window.",
            description: "Try a different time window when more comparable price history is available.",
          },
          errorTitle: "Couldn't load price trends",
          errorDescription: "Please try again.",
          retry: "Try again",
        },
      },
    },
    bugReport: {
      label: "Report a bug",
      open: "Report a bug",
      tooltip: "Bug report & feature request",
      title: "Report a bug",
      description: "Send the problem details to our team. A screenshot is included when available.",
      submit: "Send report",
      submitting: "Sending...",
      successTitle: "Report created in Linear",
      successToast: "Bug report {{issue}} created",
      actions: {
        cancel: "Cancel",
        close: "Close",
        remove: "Remove",
      },
      fields: {
        description: "Description",
        descriptionPlaceholder: "What did you expect, and what happened instead?",
      },
      screenshot: {
        label: "Screenshot",
        capture: "Capture screenshot",
        capturing: "Capturing screenshot...",
        attach: "Attach screenshot",
        retry: "Try screenshot again",
        retake: "Retake",
        error: "Could not capture a screenshot. You can still submit the report.",
        tooLarge: "Screenshot must be 4 MB or smaller.",
        unsupportedFile: "Choose an image file for the screenshot.",
        previewAlt: "Bug report screenshot preview",
        selectInstructions: "Drag to select an area · Esc to cancel",
        selectCancel: "Cancel",
      },
      errors: {
        description: "Enter at least 10 characters in the description.",
        submit: "Could not send the bug report.",
      },
    },
    medicines: {
      noSelectionTitle: "No medicine selected",
      noSelectionDescription: "Search for a medicine and pick one from the results to see its details.",
      actions: {
        addGroup: "Add all",
        findAnalog: "Find analog",
        addToCart: "Cart",
        removeFromCart: "Remove from cart",
        showInfo: "Show info",
        showCertificate: "Show related certificate",
        goToOffer: "Go to offer",
      },
      analogues: {
        title: "Analogues",
        forMedicine: "Analogues of",
        errorTitle: "Failed to load analogues",
        emptyTitle: "No analogues found",
        emptyDescription: "No matching medicines by ATC code or international name.",
        noMatchesTitle: "No matches for filter",
        noMatchesDescription: "Try clearing the dosage form filter to see all analogues.",
        selectTitle: "Select an analogue",
        selectDescription: "Pick an item from the list to see full details.",
        apply: "Apply",
      },
      dosageForms: {
        tablet: "tablet",
        capsule: "capsule",
        syrup: "syrup",
        solution: "solution",
        suspension: "suspension",
        drops: "drops",
        injection: "injection",
        infusion: "infusion",
        powder: "powder",
        granule: "granule",
        ointment: "ointment",
        cream: "cream",
        gel: "gel",
        lotion: "lotion",
        inhaler: "inhaler",
        aerosol: "aerosol",
        spray: "spray",
        suppository: "suppository",
        pessary: "pessary",
        enema: "enema",
        patch: "patch",
        paste: "paste",
        pastille: "pastille",
      },
      units: {
        mg: "mg",
        g: "g",
        mcg: "mcg",
        kg: "kg",
        ml: "ml",
        l: "l",
        iu: "IU",
        percent: "%",
        pcs: "pcs",
      },
      finder: {
        title: "Medicine Finder",
        description: "Fuzzy-search medicines, compare variants grouped by brand, and inspect price movement by period.",
        placeholder: "Find medicines, e.g. paracetamol 500",
        minChars: "Type at least 3 characters",
        selected: "Selected",
        pickMedicine: "Pick a medicine",
        startAvg: "Start avg",
        endAvg: "End avg",
        change: "Change",
        range: "Range",
        hints: {
          navigate: "navigate",
          select: "select",
          actions: "actions",
          close: "close",
        },
      },
      recommendations: {
        optionLabel: "Recommend medicines from patient text",
        optionDescription: "Rank catalog matches",
        backToSearch: "Back to search",
        title: "Medicine catalog recommendations",
        description: "Ranked catalog matches, evidence, and safety flags.",
        loading: "Loading ranked catalog matches",
        recommendationCount_one: "{{count}} recommendation",
        recommendationCount_other: "{{count}} recommendations",
        candidateCount_one: "{{count}} candidate evaluated",
        candidateCount_other: "{{count}} candidates evaluated",
        emptyTitle: "No catalog matches returned.",
        emptyDescription_one: "{{count}} total candidate was evaluated.",
        emptyDescription_other: "{{count}} total candidates were evaluated.",
        catalogMatch: "Catalog match",
        evidence: "Evidence",
        safetyWarnings: "Safety warnings",
        errors: {
          emptyQuery: "Enter patient text to match against the catalog.",
          queryTooLong: "Patient text must be 1000 characters or less.",
          limit: "Limit must be between 1 and 50.",
          age: "Age must be a non-negative value up to 130.",
          load: "Unable to load medicine recommendations.",
        },
      },
      searchResults: {
        title: "Search results",
        description: "Variants are grouped to make strength, form, pack, and country differences easier to compare.",
        emptyTitle: "No matches found",
        emptyDescription: "Try a broader medicine name or remove extra strength/pack details from the query.",
      },
      trend: {
        title: "Price trend",
        selectedTitle: "{{name}} pricing trend",
        description: "Select a result from the finder to load its pricing history.",
        selectedDescription: "Trend data from /daily-prices?medicine_id={{id}}",
        noMedicineTitle: "No medicine selected",
        noMedicineDescription: "Choose one of the search results to load summary stats and trend history.",
        refreshingTitle: "Refreshing trend...",
        refreshingDescription: "Loading the latest price data.",
        refreshingLabel: "Refreshing trend…",
        emptyTitle: "No price data for this period",
        emptyDescription: "The medicine is selected, but the backend returned no trend points for the chosen window.",
        wholesale: "Wholesale",
        retail: "Retail",
        stockTurnover: "Stock turnover",
        latestWholesaleOffers: "Latest wholesale offers",
        historicalLeaders: "Historical leaders: {{medicine}}",
        loadingLatestOffers: "Loading latest offers...",
        noLatestWholesaleOffers: "No latest wholesale offers.",
        offersBadgeCheapest: "Cheapest",
        offersBadgeMostExpensive: "Most expensive",
        offersBadgePromo: "Promo",
        offersIssued: "Issued {{date}}",
        offersExpires: "exp. {{date}}",
        offersOpenSource: "Open source price list",
        noWholesaleHistory: "No wholesale history.",
        noRetailHistory: "No retail history.",
        noHistory: "No history available.",
        turnoverRate: "Turnover rate",
        organizations: "organizations",
        median: "Median",
        min: "Min",
        max: "Max",
        movingAverage: "10d MA",
        wholesaleChartAria: "Wholesale and retail trend chart",
        turnoverChartAria: "Stock turnover trend chart",
        periodSummary: "{{points}} points loaded",
        showAll: "Show all",
        comparingMedicines: "Comparing {{count}} medicines",
        enableAtLeastOneMetric: "Enable at least one metric to see data.",
        referentWholesale: "Referent (wholesale)",
        referentRetail: "Referent (retail)",
      },
      referent: {
        sectionTitle: "Gov. ref. prices",
        wholesalePrice: "Wholesale",
        retailPrice: "Retail",
        referentPrice: "Referent price",
        registrationNumber: "Registration №",
        updated: "Updated {{date}}",
        empty: "No government referent price for this medicine.",
      },
      badges: {
        singleVariant: "Single known variant",
        prescription: "Prescription",
        otc: "OTC",
        noPrice: "No price",
        noAliases: "No aliases",
        offerCount_one: "{{count}} wholesale offer",
        lowestPrice: "from {{price}} UZS",
        offerCount_other: "{{count}} wholesale offers",
        rx: "Prescription",
        inCart: "In cart",
      },
      containerTypes: {
        ampoule: "Ampoule",
        blister: "Blister",
        bottle: "Bottle",
        box: "Box",
        canister: "Canister",
        jar: "Jar",
        packet: "Packet",
        sachet: "Sachet",
        tube: "Tube",
        vial: "Vial",
      },
      productTypes: {
        cosmetic: "Cosmetic",
        device: "Medical device",
        medicine: "Medicine",
        supplement: "Supplement",
      },
      labels: {
        form: "Form",
        strength: "Strength",
        volume: "Volume",
        dosageForm: "Dosage Form",
        containerType: "Container",
        pack: "Pack",
        country: "Country",
        vendor: "Manufacturer",
        score: "Score",
        id: "ID",
        variantCount_one: "{{count}} variant",
        variantCount_other: "{{count}} variants",
        packPieces: "№{{count}}",
        averagePrice: "Average price",
        minimumPrice: "Minimum price",
        maximumPrice: "Maximum price",
      },
      details: {
        title: "Details",
        groups: {
          summary: "Summary",
          use: "Use",
          safety: "Safety",
          pharmacology: "Pharmacology",
          storage: "Storage",
        },
        displayName: "Display name",
        tradeNameLatin: "Latin trade name",
        dosageFormText: "Dosage form",
        activeSubstance: "Active substance",
        clinicalPharmacologicalGroup: "Clinical pharmacological group",
        pharmacotherapeuticGroup: "Pharmacotherapeutic group",
        manufacturerName: "Manufacturer",
        contactOrganizationName: "Contact organization",
        icd10Codes: "ICD-10 codes",
        usedFor: "Used for",
        indications: "Indications",
        contraindications: "Contraindications",
        dosageInstructions: "Dosage Instructions",
        sideEffects: "Side Effects",
        pregnancyLactation: "Pregnancy and lactation",
        hepaticImpairment: "Hepatic impairment",
        renalImpairment: "Renal impairment",
        pediatricUse: "Pediatric use",
        geriatricUse: "Geriatric use",
        specialInstructions: "Special instructions",
        overdose: "Overdose",
        composition: "Composition",
        pharmacologicalAction: "Pharmacological action",
        pharmacokinetics: "Pharmacokinetics",
        storageConditions: "Storage Conditions",
        pharmacyReleaseTerms: "Pharmacy release terms",
        drugInteractions: "Drug interactions",
        vendor: "Vendor",
        shelfLifeYear_one: "{{count}} year",
        shelfLifeYear_other: "{{count}} years",
        shelfLifeMonth_one: "{{count}} month",
        shelfLifeMonth_other: "{{count}} months",
        shelfLife: "Shelf life",
        icdCodes: "ICD Codes",
        variations: "Variations",
        variationsOther: "Other",
        certificates: "Certificates",
        rxBadge: "Prescription",
        atcLabel: "ATC {{code}}",
        source: "Source",
        sourceNamed: "{{source}} source",
        openSource: "Open source",
        openSourceNamed: "Open {{source}} source",
        sourceUpdated: "updated {{date}}",
        vitalEssential: "Vital and essential medicine",
      },
    },
    account: {
      edit: {
        title: "Edit Profile",
        description: "Update your name as it appears across the app.",
        firstName: "First name",
        lastName: "Last name",
        phone: "Phone number",
        phoneHelp: "Contact support to change your phone.",
        submit: "Save changes",
        submitting: "Saving…",
        success: "Profile updated.",
        errors: {
          firstNameRequired: "Enter your first name.",
          firstNameMax: "First name is too long.",
          lastNameRequired: "Enter your last name.",
          lastNameMax: "Last name is too long.",
          generic: "Unable to update profile. Please try again.",
        },
      },
      password: {
        title: "Change Password",
        description: "Set a new password for your account.",
        currentPassword: "Current password",
        newPassword: "New password",
        confirmPassword: "Confirm new password",
        submit: "Update password",
        submitting: "Updating…",
        success: "Password updated.",
        modal: {
          title: "Change password",
          description: "Enter your current password, then choose a new one.",
          save: "Update password",
          saving: "Updating…",
        },
        errors: {
          currentRequired: "Enter your current password.",
          currentInvalid: "Current password is incorrect.",
          passwordRequired: "Enter a new password.",
          passwordMin: "Password must be at least 8 characters.",
          passwordMax: "Password is too long.",
          confirmRequired: "Confirm your new password.",
          mismatch: "Passwords do not match.",
          generic: "Unable to change password. Please try again.",
        },
      },
      mockBadge: {
        badge: "Mock data",
        title: "This page is under development",
        description:
          "All values shown here are mock data, not real account data. Full functionality will be wired up in a later iteration.",
      },
      overview: {
        title: "Account",
        description: "Personal information and account settings.",
        profile: {
          title: "Personal information",
          fullName: "Full name",
          phone: "Phone number",
          email: "Email",
          role: "Role",
          organization: "Organization",
          memberSince: "Member since",
          notSet: "Not set",
          edit: "Edit profile",
        },
        security: {
          title: "Security",
          description: "Manage sign-in and security settings.",
          twoFactor: "Two-factor authentication",
          twoFactorOff: "Off",
          twoFactorOn: "On",
          changePassword: "Change password",
        },
        sessions: {
          title: "Active sessions",
          description: "Devices you are currently signed in on.",
          current: "Current device",
          signOut: "Sign out",
          devices: {
            mac: "MacBook Pro · Chrome",
            windows: "Windows PC · Edge",
            ios: "iPhone · Safari",
          },
          locations: {
            tashkent: "Tashkent, Uzbekistan",
            samarkand: "Samarkand, Uzbekistan",
          },
          lastSeen: "active {{when}}",
          minutesAgo: "{{count}} min ago",
          hoursAgo: "{{count}} h ago",
          daysAgo: "{{count}} d ago",
        },
      },
      billing: {
        title: "Billing",
        description: "Plan, payment methods and invoices.",
        plan: {
          title: "Current plan",
          name: "Pro",
          priceMonthly: "{{amount}} / month",
          renewsOn: "Renews on {{date}}",
          manage: "Manage plan",
          features: {
            unlimited: "Unlimited price-list uploads",
            priority: "Priority support",
            analytics: "Advanced analytics",
          },
        },
        paymentMethod: {
          title: "Payment method",
          primary: "Primary card",
          expires: "Expires {{date}}",
          addNew: "Add new card",
        },
        invoices: {
          title: "Billing history",
          empty: "No invoices yet.",
          columns: {
            number: "Invoice",
            date: "Date",
            amount: "Amount",
            status: "Status",
            action: "Action",
          },
          status: {
            paid: "Paid",
            pending: "Pending",
            failed: "Failed",
          },
          download: "Download",
        },
      },
      notificationsPage: {
        title: "Notifications",
        description: "Choose which alerts you receive and review recent activity.",
        preferences: {
          title: "Notification preferences",
          description: "Pick which channels deliver each type of alert.",
          channels: {
            email: "Email",
            push: "Push",
            sms: "SMS",
          },
          categories: {
            orders: "Order updates",
            priceChanges: "Price changes",
            system: "System messages",
            marketing: "Marketing and promotions",
          },
        },
        feed: {
          title: "Recent notifications",
          empty: "No new notifications.",
          markAllRead: "Mark all as read",
          unread: "New",
          items: {
            orderConfirmed: {
              title: "Order confirmed",
              body: "Order #1284 was accepted by the supplier.",
              when: "10 min ago",
            },
            priceDrop: {
              title: "Price dropped",
              body: 'Tracked item "Paracetamol 500mg" went down 12%.',
              when: "1 h ago",
            },
            stockAlert: {
              title: "Low stock",
              body: '"Aspirin 100mg" is running low at your warehouse.',
              when: "3 h ago",
            },
            invoiceReady: {
              title: "New invoice",
              body: "Your April invoice is ready to view.",
              when: "Yesterday",
            },
            systemUpdate: {
              title: "System update",
              body: "The platform has been updated with new features.",
              when: "2 d ago",
            },
          },
        },
      },
    },
    organizations: {
      create: {
        title: "Create your organization",
        description:
          "You need to create an organization before you can use the dashboard. You will be set as its owner.",
        name: "Organization name",
        address: "Address",
        city: "City",
        region: "Region",
        regionPlaceholder: "Select a region",
        district: "District",
        type: "Organization type",
        typePlaceholder: "Select a type",
        logo: "Logo",
        logoUpload: "Upload image",
        phones: "Phone numbers",
        addPhone: "Add phone",
        removePhone: "Remove phone",
        submit: "Create organization",
        submitting: "Creating...",
        success: "Organization created successfully.",
        errors: {
          nameRequired: "Organization name is required.",
          nameMax: "Name must be at most 255 characters.",
          addressMax: "Address must be at most 500 characters.",
          cityMax: "City must be at most 255 characters.",
          districtMax: "District must be at most 255 characters.",
          regionInvalid: "Please select a valid region.",
          typeRequired: "Organization type is required.",
          typeInvalid: "Please select a valid type.",
          phoneInvalid: "Phone must match 998XXXXXXXXX.",
          phonesMax: "You can add at most 20 phone numbers.",
          alreadyHasOrganization: "You already belong to an organization.",
          generic: "Unable to create organization. Please try again.",
        },
      },
      types: {
        retail: "Retail",
        wholesale: "Wholesale",
      },
      regions: {
        andijon: "Andijon",
        buxoro: "Buxoro",
        fargona: "Farg'ona",
        jizzax: "Jizzax",
        qashqadaryo: "Qashqadaryo",
        qoraqalpogiston: "Qoraqalpog'iston",
        namangan: "Namangan",
        navoiy: "Navoiy",
        samarqand: "Samarqand",
        sirdaryo: "Sirdaryo",
        surxondaryo: "Surxondaryo",
        toshkent: "Toshkent",
        toshkent_viloyati: "Toshkent viloyati",
        xorazm: "Xorazm",
      },
      edit: {
        title: "Edit organization",
        description: "Update your organization details.",
        submit: "Save changes",
        submitting: "Saving...",
        success: "Organization updated successfully.",
        loadError: "Unable to load organization.",
        noOrganization: "You do not belong to an organization yet.",
        sections: {
          brandTitle: "Brand",
          brandDescription: "The logo and name partners see when they interact with your organization.",
          locationTitle: "Location",
          locationDescription: "Where is your organization based?",
          contactTitle: "Phone numbers",
          contactDescription: "Buyers will use these to reach you.",
        },
        errors: {
          generic: "Unable to update organization. Please try again.",
        },
      },
      list: {
        searchPlaceholder: "Search organizations",
        loadErrorTitle: "Unable to load organizations",
        emptyTitle: "No organizations found",
        emptyDescription: "Try a different search term.",
        addressMissing: "Address not provided",
        latestPrice: "price",
        typeFilter: {
          all: "All",
        },
      },
      info: {
        chooseOrganization: "Choose an organization",
        detailsHint: "Select an organization from the left to inspect contact details and Telegram links.",
        noPhones: "No phone numbers available.",
        lastFile: "Last file:",
        noGroups: "No Telegram groups connected.",
        notAvailable: "Not available",
        groupFallback: "Group {{id}}",
        approved: "Approved {{date}}",
      },
      telegram: {
        title: "Telegram channels",
        description: "Latest crawl status for each connected Telegram channel.",
        empty: "No Telegram channels connected yet.",
        lastCrawl: "Last crawl",
        lastFile: "Last file",
        notCrawled: "Not crawled yet",
        noFile: "No files yet",
        disabled: "Disabled",
      },
      workspace: {
        title: "Workspace",
        filesDescription: "Review uploaded price lists and open one file at a time.",
        importDescription: "Queue a new workbook import for the selected organization.",
        tabs: {
          files: "Price lists",
          import: "Import",
        },
      },
      files: {
        loadErrorTitle: "Unable to load organization details",
        emptyTitle: "No price list files found",
        emptyDescription: "This organization does not have any visible XLS price lists yet.",
        issueDateMissing: "Issue date not available",
        status: {
          processing: "Processing",
          completed: "Completed",
          failed: "Failed",
        },
        rows: "{{count}} rows",
        sheet: "Sheet: {{value}}",
        payment: "Payment: {{value}}%",
        paginationSummary: "Showing {{from}}–{{to}} of {{total}}",
        region: "Region",
        allRegions: "All regions",
        regions: {
          andijon: "Andijon",
          bukhara: "Bukhara",
          fergana: "Fergana",
          jizzakh: "Jizzakh",
          karakalpakstan: "Karakalpakstan",
          namangan: "Namangan",
          navoiy: "Navoiy",
          qashqadaryo: "Qashqadaryo",
          samarqand: "Samarqand",
          sirdaryo: "Sirdaryo",
          surxondaryo: "Surxondaryo",
          tashkent: "Tashkent",
          xorazm: "Xorazm",
        },
      },
      indexedItems: {
        title: "Indexed price list items",
        description: "Parsed items returned by the backend for the selected file.",
        filterPlaceholder: "Filter indexed items across all columns",
        clickRow: "Click a row to open details",
        loadErrorTitle: "Unable to load price list items",
        noFileTitle: "No file selected",
        noFileDescription: "Choose a price list file to inspect its indexed items.",
        noItemsTitle: "No indexed items returned",
        noItemsDescription: "The selected file does not have parsed items yet.",
        fileDescription: "{{fileName}}",
        rowCount: "{{count}} rows",
        downloadXls: "XLS",
        downloadXlsx: "XLSX",
      },
      medicineSheet: {
        title: "Medicine details",
        description: "Review medicine attributes, pricing context, and price movement from the indexed row.",
        loadErrorTitle: "Unable to load medicine details",
        missingIdTitle: "Medicine ID is missing",
        missingIdDescription: "This indexed row does not have a linked medicine record to open.",
        currentRowPrice: "Current row price",
        indexedRow: "Indexed row",
        trackedSamples: "Tracked samples",
        periodDetail: "Period: {{period}}",
        priceChange: "Price change",
        vsPeriodStart: "{{value}}% vs period start",
        notEnoughHistory: "Not enough history yet",
        priceMovement: "Price movement",
        priceMovementDescription: "Daily average, minimum, and maximum prices for the selected medicine.",
        periodPlaceholder: "Period",
        noHistoryTitle: "No price history available",
        noHistoryDescription: "This medicine does not have enough tracked price data for the selected period.",
        profileTitle: "Medicine profile",
        profileDescription: "Core attributes from the medicine catalog and the selected indexed row.",
        indexedContextTitle: "Indexed row context",
        indexedContextDescription: "Source data from the selected price list row.",
        trendStatus: "Trend status",
        labels: {
          name: "Name",
          internationalName: "International name",
          dosageForm: "Dosage form",
          strength: "Strength",
          volume: "Volume",
          pack: "Pack",
          packageQuantity: "Package quantity",
          atcCode: "ATC code",
          vendorId: "Manufacturer ID",
          prescription: "Prescription",
          listedPrice: "Listed price",
          minMaxPrice: "Min / Max price",
          priceListFileId: "Price list file ID",
          medicineId: "Medicine ID",
          rawName: "Raw name",
          vendor: "Manufacturer",
          expiryDate: "Expiry date",
          issueDate: "Issue date",
          crawledAt: "Crawled at",
          required: "Required",
          notRequired: "Not required",
        },
      },
      import: {
        importType: "Import type",
        dragAndDrop: "or drag & drop here",
        importFile: "Import file",
        priceList: "Price list",
        orderList: "Order list",
        noWorkbook: "No workbook selected",
        readyToImport: "Ready to import this workbook.",
        invalidFileType: "Choose an .xlsx, .xls, or .csv file.",
        supportedFormats: "Supported formats: .xlsx, .xls, .csv",
        capacityHint: "{{stored}}/{{storageLimit}} files stored · {{active}}/{{concurrentLimit}} active",
        concurrentLimitReached:
          "Only {{limit}} simultaneous imports are allowed. Wait for the current imports to finish.",
        storageLimitReached:
          "Storage limit reached: your organization can store up to {{limit}} imported files. Delete an existing file before importing a new one.",
        queueing: "Queueing import...",
        signInRequired: "Sign in to import workbook files.",
        noOrganizationLinked: "Your account is not linked to an organization yet.",
        selectOrganization: "Select an organization before importing files.",
        switchOrganization: "Switch to your organization to import files with your account.",
        queuedNotice: "{{fileName}} queued for import",
        queuedNoticeFallback: "Import queued",
        queueTitle: "Import queue",
        queueDescriptionActive: "Queued and processing workbook jobs for your account.",
        queueDescriptionIdle: "No running jobs right now.",
        waitingToStart: "Waiting to start",
        inProgress: "Import in progress",
        loadingJobs: "Loading import jobs...",
        noActiveTitle: "No active imports",
        noActiveDescription: "Start an Excel or CSV import to see queue progress here.",
        jobLabel: "Job {{id}}",
        sheetsProgress: "{{completed}}/{{total}} sheets",
        importedSheetsTitle: "Imported sheets",
        importedSheetsDescription: "Previously imported workbooks. Click a row to inspect its contents.",
        noImportedSheetsTitle: "No imported sheets yet",
        noImportedSheetsDescription: "Import an Excel or CSV file to see it listed here.",
        statusCompleted: "Completed",
        statusFailed: "Failed",
        deleteAction: "Delete sheet",
        deleteCancel: "Cancel",
        deleteConfirmAction: "Delete",
        deleteConfirmTitle: "Delete imported sheet?",
        deleteConfirmDescription: "This will permanently delete {{name}} and its imported rows.",
        deleteSuccess: "Imported sheet deleted",
        deleteError: "Could not delete imported sheet",
        listColumns: {
          file: "File",
          rows: "Rows",
          imported: "Imported",
          status: "Status",
        },
        fileLabel: "File name",
        sheetDetailTitle: "Sheet contents",
        sheetDetailDescription: "Rows imported from this workbook.",
        loadErrorTitle: "Could not load sheet contents",
        loadErrorDescription: "Something went wrong while loading the sheet data. Please try again in a moment.",
        sheetRowsSearchPlaceholder: "Filter by name, IDs, price, or raw row values",
        sheetRowsEmpty: "No rows match your filters.",
        sheetRowsCount: "Showing {{from}}-{{to}} of {{total}}",
        rows: "rows",
        priceEdit: {
          success: "Price updated",
          error: "Could not update price",
          placeholder: "Price in UZS",
          ariaLabel: "Edit price",
        },
        summary: {
          matched: "matched",
          notFound: "not found",
        },
        columns: {
          name: "Name",
          price: "Price",
          referentWholesalePrice: "Ref. wholesale",
          vendorName: "Vendor Name",
          rowIndex: "Row Index",
          code: "Code",
          expiryDate: "Expiry Date",
          markup: "Markup",
          vat: "VAT",
          priceNoVat: "Price w/o VAT",
        },
        pricing: {
          column: "Sell rec.",
          targetMargin: "Target margin",
          payment: "Payment",
          termAdjustment: "Term adj.",
          region: "Region",
          action: "Recommend prices",
          selected: "{{count}} selected",
          costPrice: "Cost price",
          missingCost: "Enter a positive cost price for each selected row.",
          infeasible: "Infeasible",
          selectRow: "Select row for pricing recommendation",
        },
      },
      table: {
        columns: {
          rawName: "Raw name",
          vendor: "Manufacturer",
          packageQuantity: "Package qty",
          expiry: "Expiry",
          issueDate: "Issue date",
          crawledAt: "Crawled at",
          price: "Price",
        },
      },
      priceHover: {
        unknownMedicine: "Medicine",
        missingMedicineId: "No medicine (medicine_id) is linked to this row.",
        noLiveOffers: "No live wholesale offers found for medicine ID {{medicineId}}.",
        noChartData: "No chart data available.",
        daysWindow: "{{count}} days",
        vsMedian: "vs median",
        recommended: "Recommended",
        referentWholesale: "Referent (wholesale)",
        referentRetail: "Referent (retail)",
        offersCount: "Wholesale offers",
        vsCheapest: "vs cheapest",
        cheaperOffers: "CHEAPER OFFERS",
        noCheaper: "No cheaper offers",
        expensiveOffers: "MORE EXPENSIVE",
        noExpensive: "No more expensive offers",
        expiryError: "Could not load expiry history.",
        expiryEmpty: "No expiry history available.",
        expiryTurnover: "Turnover rate",
        expiryOrgsLabel: "orgs",
        orgFallback: "Org {{id}}",
        tabs: {
          wholesale: "Wholesale",
          retail: "Retail",
          expiry: "Expiry",
        },
        series: {
          median: "Median",
          min: "Min",
          max: "Max",
          avg: "10k MA",
          turnoverRate: "Turnover rate",
          offerCount: "Offer count",
        },
      },
      ratings: {
        title: "Organization Ratings",
        description:
          "Wholesale suppliers ranked by price competitiveness, catalog variety, activity, and promotions over the last 90 days.",
        allRegions: "All regions",
        count: "{{count}} organizations",
        errorTitle: "Failed to load rankings",
        emptyTitle: "No organizations yet",
        emptyDescription: "No wholesale organizations match the current filters.",
        sortOptions: {
          overall: "Overall score",
          cheapest_pct: "Best prices",
          variety: "Widest variety",
          medicines: "Most exclusive medicines",
          promotion_pct: "Most promotions",
          freshness: "Most active",
        },
        paymentOptions: {
          p100: "100% payment",
          p50: "50% payment",
          p30: "30% payment",
        },
        scoreLabels: {
          price: "Price",
          variety: "Variety",
          medicines: "Exclusive",
          freshness: "Freshness",
          promotions: "Promotions",
        },
        metrics: {
          medicines: "{{count}} medicines",
          exclusiveMedicines: "{{count}} exclusive",
          cheapest: "{{pct}} cheapest",
          promo: "{{pct}} promo",
          daysActive: "{{days}}/90 days active",
        },
        seeMetrics: "See metrics",
        metricsDrawerTitle: "Metrics",
        drilldown: {
          openAria: "Show the {{count}} {{metric}} medicines for {{organization}}",
          title: { exclusive: "exclusive", cheapest: "cheapest", promotion: "promotion" },
          description: {
            exclusive: "Medicines offered only by this supplier in the last {{days}} days.",
            cheapest: "Medicines where this supplier had the lowest price in the last {{days}} days.",
            promotion: "Promotional offers from this supplier in the last {{days}} days.",
          },
          summary: { matches: "Matches", medicines: "Medicines", window: "Window" },
          columns: {
            medicine: "Medicine",
            daysOffered: "Days offered",
            offers: "Offers",
            price: "Price",
            runnerUp: "Next cheapest",
            delta: "Gap",
            promo: "Promotion",
            issued: "Last seen",
            expiry: "Expiry",
            vendor: "Vendor",
          },
          competitors: "vs {{count}} suppliers",
          daysWindow: "{{count}} days",
          searchPlaceholder: "Search medicines",
          clearSearch: "Clear search",
          sortLabel: "Sort medicines",
          sortOptions: {
            matched_days: "Days offered",
            matched_offers: "Offers",
            last_matched_date: "Last seen",
            matched_price: "Price",
          },
          errorTitle: "Unable to load medicines",
          emptyTitle: "No matching medicines",
          emptyDescription: {
            exclusive: "No exclusive medicines were found for this period.",
            cheapest: "No lowest-price medicines were found for this period.",
            promotion: "No promotional medicines were found for this period.",
          },
        },
      },
      salesHover: {
        unknownMedicine: "Medicine",
        missingMedicineId: "No medicine (medicine_id) is linked to this row.",
        loadError: "Failed to load sales data.",
        daysIncluded: "days included",
        chartTitle: "Retail sales flow",
        noData: "No sales data available.",
        avgDailySales: "90d avg sold",
        medianDailySales: "90d median sold",
        totalSales: "Total sold",
        includedDays: "Days included",
        rank: "Rank",
        percentile: "Percentile",
        totalDiffVsMedian: "Total vs peer median",
        dailyDiffVsMedian: "Daily vs peer median",
        atcLeaders: "Same ATC code leaders",
        avgPerPharmacy: "Avg sold / pharmacy",
        daysWithSales: "days with sales",
        legend: {
          sales: "Sold",
          gain: "Restocked",
          net: "Net",
          peerMedian: "Same ATC code median",
        },
      },
      team: {
        roles: {
          owner: "Owner",
          admin: "Admin",
          member: "Member",
        },
        members: {
          title: "Team members",
          description: "People with access to this organization.",
          columns: {
            name: "Name",
            phone: "Phone",
            role: "Role",
            joinedAt: "Joined",
          },
          empty: "No members yet.",
          remove: "Remove",
          removeConfirm: {
            title: "Remove member?",
            description: "{{name}} will lose access to this organization.",
            confirm: "Remove",
          },
          removeSuccess: "Member removed.",
          removeError: "Could not remove member.",
          removeForbidden: "You don't have permission to remove this member.",
          removeSelfForbidden: "You can't remove yourself.",
        },
        invitations: {
          title: "Invitations",
          description: "Pending invitations expire automatically.",
          empty: "No pending invitations.",
          invite: "Invite member",
          copyLink: "Copy link",
          revoke: "Revoke",
          revokeSuccess: "Invitation revoked.",
          revokeError: "Could not revoke invitation.",
          revokeConflict: "This invitation can no longer be revoked.",
          columns: {
            phone: "Phone",
            email: "Email",
            role: "Role",
            expiresAt: "Expires",
          },
          form: {
            title: "Invite a member",
            description: "Send an invitation link to a phone number.",
            phone: "Phone",
            email: "Email (optional)",
            emailPlaceholder: "name@example.com",
            role: "Role",
            submit: "Create invitation",
            submitting: "Creating…",
            success: "Invitation created.",
            errors: {
              phoneRequired: "Phone is required.",
              phoneInvalid: "Enter a valid phone number.",
              emailInvalid: "Enter a valid email.",
              duplicate: "This phone is already invited or a member.",
              generic: "Could not create invitation.",
            },
          },
          copy: {
            title: "Invitation link",
            description: "Share this link with {{phone}} so they can join.",
            done: "Done",
            error: "Couldn't copy the link.",
          },
        },
        joinRequests: {
          title: "Pending join requests",
          description: "People asking to join this organization.",
          columns: {
            name: "Name",
            phone: "Phone",
            requestedAt: "Requested",
          },
          approve: "Approve",
          reject: "Reject",
          approveSuccess: "Request approved.",
          approveError: "Could not approve the request.",
          rejectSuccess: "Request rejected.",
          rejectError: "Could not reject the request.",
          alreadyDecided: "This request has already been handled.",
        },
      },
      join: {
        title: "Join an organization",
        description: "Search for an organization and send a request to join.",
        greeting: "Welcome, {{name}}. Search for an organization to send a join request.",
        searchPlaceholder: "Search organizations…",
        empty: "Start typing to search for organizations.",
        noResults: "No organizations match your search.",
        requestButton: "Request to join",
        requestSuccess: "Request sent.",
        requestError: "Could not send the request.",
        errors: {
          alreadyInOrg: "You're already in an organization.",
          alreadyPending: "You already have a pending request.",
        },
      },
      pending: {
        title: "Request pending",
        description: "Your join request is awaiting approval from a manager.",
        targetLabel: "Organization",
        cancel: "Cancel request",
        cancelSuccess: "Request cancelled.",
        cancelError: "Could not cancel the request.",
      },
    },
    wholesaleOffers: {
      title: "Wholesale Offers",
      totalRows: "{{count}} offers",
      emptyTitle: "No offers found",
      emptyDescription: "Try clearing the organization filter or check back later.",
      badges: {
        supplement: "Supplement",
      },
      footerSummary: {
        offers: "{{count}} offers",
        medicines: "{{count}} medicines",
        organizations: "{{count}} organizations",
      },
      promoBadge: "Promo",
      promo: {
        popup: {
          ariaLabel: "Promotion details",
          defaultTitle: "Promotion",
          priceLabel: "Price",
          discount: "{{pct}}% off",
          combo: "Buy {{buy}}, get {{bonus}} free",
          bonusMedicine: "Bonus: {{name}}",
          validFromThrough: "Valid {{start}} – {{end}}",
        },
      },
      expiresIn_one: "Expires in {{count}} month",
      expiresIn_other: "Expires in {{count}} months",
      expiresIn_zero: "Expires this month",
      expired: "Expired",
      batchAge: {
        noExpiry: "No expiry",
        tooltip: "Estimated from wholesaler + medicine + expiry date. This is not a true batch/lot ID.",
      },
      leaders: {
        title: "Leaders",
        empty: "Not enough competing offer history.",
        headers: {
          supplier: "Supplier",
          wins: "Wins",
          rate: "Rate",
          price: "Price",
        },
        best: "Best",
        rankTooltip: "Leaderboard position for the selected period.",
        winsTooltip: "Lowest price on {{wins}} of {{dates}} comparable dates. {{ties}} of those wins were ties.",
        rateTooltip: "Share of comparable dates where this supplier had the lowest price.",
        currentPriceTooltip: "Current price: {{price}} so'm.",
        bestPriceTooltip: "Current price: {{price}} so'm — best current offer.",
        priceGapTooltip: "Current price: {{price}} so'm — {{gap}} so'm above the best current offer.",
        noCurrentPriceTooltip: "No offer on the current date.",
        noCurrentPriceLastWinTooltip: "No offer on the current date. Last win: {{date}}.",
      },
      actions: {
        cheapestOffer: "Cheapest offer",
        mostExpensiveOffer: "Most expensive offer",
        addToCart: "Cart",
        removeFromCart: "Remove from cart",
        decreaseQuantity: "Decrease quantity",
        increaseQuantity: "Increase quantity",
        showPricePlan: "Show price plan",
        showExpirationObservations: "Show expiration observations",
        openMedicine: "Open medicine",
        openOrganization: "Go to organization",
        openVendor: "Go to vendor",
        openReferentPrice: "View reference price",
        showOnlyMedicine: "Show only this medicine",
        showCheaperSameMedicine: "Cheaper same medicine",
        showCheaperAnalogue: "Cheaper analogue",
        cheaperSavingsLine: "Save {{amount}} so'm ({{percent}}%) · {{price}} so'm",
        rawName: "Raw name",
        showOnlyOrganization: "Show only this organization",
        showPurchaseHistory: "Purchase history",
      },
      purchaseHistory: {
        title: "Previously purchased",
        totalSummary: "Total purchased: {{count}} pcs.",
        orderRow: "Order #{{shortId}}",
        orderQuantity: "{{count}} pcs.",
        empty: "No previous purchases of this item.",
      },
      tone: {
        cheaper: "Cheaper than market",
        moreExpensive: "More expensive than market",
      },
      toneTooltip: {
        cheaper: "This offer is {{percent}}% cheaper than the market average.",
        moreExpensive: "This offer is {{percent}}% more expensive than the market average.",
      },
      marketTrend: {
        down: "Market down",
        up: "Market up",
        tooltip: "90-day market average trend for this medicine and payment terms.",
      },
      indicators: {
        cheapestAmongAnalogues: "Cheapest among analogues",
        onlyAnalogousOffer: "Only offer among analogues",
      },
      outlierWarning: "This price looks unusual and might be incorrect.",
      referentPriceCapturedOn: "Captured on {{date}}",
      referentPriceCurrentTooltip: "Current referent price (effective {{date}})",
      referentPriceUpcomingTooltip: "{{price}} takes effect on {{date}}",
      referentPriceUpcomingLabel: "from {{date}}",
      variationFilters: {
        hideInactive: "Hide inactive",
        showAll: "Show all",
        dosageForm: "Form",
        strength: "Strength",
        volume: "Volume",
        pack: "Pack",
        containerType: "Container",
        productType: "Type",
      },
      columns: {
        medicine: "Medicine",
        organization: "Organization",
        region: "Region",
        vendor: "Vendor",
        price: "Price with VAT",
        normalizedUnitPrice: "Unit price",
        markup: "Markup",
        referentWholesalePrice: "Ref. wholesale",
        referentRetailPrice: "Ref. retail",
        issueDate: "Offer date",
        expiryDate: "Expiry date",
        batchAge: "Batch age",
        promotion: "Promotion",
      },
      columnsMenu: {
        label: "Columns",
        presets: {
          wholesale: "Wholesale",
          retail: "Retail",
        },
      },
      filters: {
        organizationPlaceholder: "Filter by organization",
        organizationSearchPlaceholder: "Search organizations...",
        organizationEmpty: "No organizations found",
        clearOrganization: "Clear organization filter",
        organizationIncludedCount_one: "{{count}} included",
        organizationIncludedCount_other: "{{count}} included",
        organizationExcludedCount_one: "{{count}} excluded",
        organizationExcludedCount_other: "{{count}} excluded",
        organizationIncludeAction: "Include",
        organizationExcludeAction: "Exclude",
        medicinePlaceholder: "Filter by medicine",
        medicineSearchPlaceholder: "Search medicines...",
        medicineEmpty: "No medicines found",
        medicineShowAll: 'Show all "{{query}}"',
        medicineShowAllLabel: "Search: {{query}}",
        clearMedicine: "Clear medicine filter",
        regionPlaceholder: "Filter by region",
        regionSearchPlaceholder: "Search regions...",
        regionEmpty: "No regions found",
        clearRegion: "Clear region filter",
        clearAll: "Clear",
        hasPromotion: "Promotion",
        withAnalogous: "Include analogues",
        cheapestPerMedicine: "Cheapest",
        paymentPercentage: "Payment percentage",
        paymentPercentageTooltip: "Pre-payment percentage",
        paymentOption: "{{value}}%",
        payment100: "Prepay 100%",
        payment25: "25% prepaid",
        supplement: "Supplements",
        hidePriceDecimals: "Hide decimals",
        highlighted_one: "{{count}} highlighted",
        highlighted_other: "{{count}} highlighted",
      },
      legend: {
        ariaLabel: "Show legend explaining dots and badges",
        title: "What the dots and badges mean",
        rowColors: {
          heading: "Offer status dots",
          onlyOffer: "Only offer for this medicine",
          cheapest: "Cheapest offer for this medicine, excluding analogues",
          mostExpensive: "Most expensive offer for this medicine",
        },
        statusFilters: {
          cheapest: "Cheapest",
          mostExpensive: "Most expensive",
          onlyOffer: "Only offer",
          notInMarket: "Not in market",
        },
        priceTone: {
          heading: "Price vs. market median",
        },
        indicators: {
          heading: "Indicators",
          outlier: "Price looks unusual — double-check before buying",
          promo: "Offer includes a promotion (discount or buy N + get M)",
        },
      },
      priceHistoryModal: {
        title: "History",
        current: "Current price",
        periodMin: "Period min",
        periodMax: "Period max",
        change: "Period change",
        wholesaleRetailSavings: "Wholesale vs retail",
        priceDifferenceCheaperTooltip: "Wholesale average is cheaper than retail.",
        priceDifferenceMoreExpensiveTooltip: "Wholesale average is more expensive than retail.",
        priceDifferenceSameTooltip: "Wholesale and retail averages are the same.",
        referentWholesale: "Referent (wholesale)",
        referentRetail: "Referent (retail)",
        periodSelector: "Period",
        daysUnit: "days",
        offerCount: "Offer count",
        offerCountSwitch: "Show offer count",
        dateOffers: "Date offers",
        tabs: {
          wholesale: "Wholesale",
          retail: "Retail",
          expirationObservations: "Expiration observations",
        },
        daysWindow: "Past {{count}} days",
        series: {
          median: "Median",
          min: "Min",
          max: "Max",
          avg: "Avg",
        },
        loadError: "Could not load price history.",
        empty: "No price history available.",
        hoverHint: "Hover over a date to see offers from that day.",
        offersOnDate: "Offers on {{date}}",
        offersError: "Failed to load offers for this date.",
        noOffers: "No offers recorded for this date.",
        offerAgeLabel_one: "{{count}} day old",
        offerAgeLabel_other: "{{count}} days old",
        offerAgeTooltip:
          "This offer is from the latest known earlier price list and is shown for this date because no later price change or removal was known yet.",
        batchAge: {
          title: "Batch staleness",
          description: "Estimated from wholesaler + medicine + expiry date. This is not a true batch/lot ID.",
          summaryOldest: "Oldest current",
          summaryAverage: "Average current",
          summaryWholesalers: "Wholesalers",
          currentExpiry: "Current expiry: {{date}}",
          firstSeen: "First seen {{date}}",
          observations: "{{count}} observations",
          timeline: "Expiry-run timeline",
          legendPrefix: "Timeline:",
          legendFresh: "< 30 d",
          legendAging: "30-59 d",
          legendStale: "60+ d",
          legendNoExpiry: "No expiry",
          legendLowerBound: "lower bound",
          legendWidth: "Wider runs mean the same expiry stayed unchanged longer.",
          segmentRange: "{{start}} - {{end}}",
          segmentAge: "Estimated age: {{age}}",
          segmentObservations: "{{count}} observations",
          segmentHint: "Segment width shows how long this expiry value stayed unchanged.",
          noRuns: "No expiry runs recorded.",
          empty: "No batch staleness data available.",
          error: "Could not load batch staleness.",
        },
      },
    },
    invitations: {
      accept: {
        invalidLink: {
          title: "Invalid invitation link",
          description: "This link is missing or malformed.",
        },
        redirecting: "Redirecting to login…",
        processing: "Accepting invitation…",
        success: {
          title: "You're in!",
          description: "You are now a member of {{name}}.",
          descriptionFallback: "You are now a member of this organization.",
          continue: "Continue",
        },
        errors: {
          goHome: "Go to dashboard",
          phoneMismatch: {
            title: "Phone number mismatch",
            description:
              "This invitation was sent to a different phone number. You're signed in as {{phone}}. Sign out and sign in with the invited phone.",
          },
          notFound: {
            title: "Invitation not found",
            description: "This invitation link is unknown or has been removed.",
          },
          conflict: {
            title: "Already in an organization",
            description: "You're already a member of an organization. Leave it before accepting another invitation.",
          },
          expired: {
            title: "Invitation expired",
            description: "Ask the inviter to send a new invitation.",
          },
          generic: {
            title: "Could not accept invitation",
            description: "Please try again later.",
          },
        },
      },
    },
    vendors: {
      list: {
        searchPlaceholder: "Search manufacturers",
        loadErrorTitle: "Unable to load manufacturers",
        emptyTitle: "No manufacturers found",
        emptyDescription: "Try a different search term.",
        countryMissing: "Country not specified",
      },
      info: {
        chooseVendor: "Choose a manufacturer",
        detailsHint: "Select a manufacturer from the left to view details.",
        country: "Country",
        website: "Website",
        email: "Email",
        phone: "Phone",
        address: "Address",
        description: "Description",
        notAvailable: "Not available",
        idLabel: "ID",
        copyId: "Copy ID",
        idCopied: "ID copied",
      },
      label: {
        name: "Manufacturer",
        country: "Country",
        countryUnknown: "Country not specified",
      },
    },
    certifiedMedicines: {
      title: "Certificates",
      totalRows: "{{count}} records",
      emptyTitle: "No certificates found",
      emptyDescription: "Try a different search term or clear the filters.",
      loadErrorTitle: "Unable to load certificates",
      filters: {
        searchPlaceholder: "Search by product, manufacturer, registration…",
        yearPlaceholder: "Year",
        allYears: "All years",
        countryPlaceholder: "Country",
        allCountries: "All countries",
        countrySearchPlaceholder: "Search countries…",
        countryEmpty: "No countries found",
        certifyingBodyPlaceholder: "Certifying body",
        allCertifyingBodies: "All certifying bodies",
        shelfLifePlaceholder: "Shelf life",
        shelfLifeFromPlaceholder: "From",
        shelfLifeToPlaceholder: "To",
        shelfLifeApply: "Apply",
        shelfLifeReset: "Reset",
        medicineFilter: "Medicine",
        clearAll: "Clear",
        unknownOrganization: "Unknown organization",
        dialogTitle: "Filters",
        dialogDone: "Done",
        clearSearch: "Clear search",
      },
      columns: {
        productName: "Product name",
        year: "Year",
        manufacturer: "Manufacturer",
        manufacturerCountry: "Country",
        certifyingBody: "Certifying body",
        batchSeries: "Batch series",
        registrationNumber: "Registration №",
        certificateIssuedAt: "Certificate issued",
        shelfLifeDate: "Shelf life",
        orderedBy: "Ordered by",
      },
      actions: {
        openMedicine: "Open medicine",
      },
      detail: {
        title: "Certificate details",
        description: "Full certificate record",
        id: "Record ID",
        crawledAt: "Crawled at",
        openSource: "Open on uzpharm-control.uz",
      },
    },
    referentPrices: {
      title: "Referent Prices",
      emptyTitle: "No referent prices found",
      emptyDescription: "Try a different search term or clear the filters.",
      loadErrorTitle: "Unable to load referent prices",
      unmatched: "Unmatched",
      filters: {
        searchPlaceholder: "Search by name, manufacturer, registration №…",
        currencyPlaceholder: "Currency",
        allCurrencies: "All currencies",
        matchStatusPlaceholder: "Match",
        allMatchStatuses: "All",
        matched: "Matched",
        unmatched: "Unmatched",
        clearAll: "Clear",
      },
      columns: {
        tradeName: "Trade name",
        internationalName: "INN",
        manufacturer: "Manufacturer",
        package: "Package",
        registrationNumber: "Registration №",
        currency: "Currency",
        referentPrice: "Referent price",
        wholesalePrice: "Wholesale (Sum)",
        retailPrice: "Retail (Sum)",
        matchedMedicine: "Medicine",
      },
      actions: {
        openMedicine: "Open medicine",
      },
      currencies: {
        UZS: "Sum",
        USD: "Dollar",
        EUR: "Euro",
        RUB: "Ruble",
      },
      detail: {
        title: "Referent price details",
        description: "Full referent price record",
      },
    },
    expiryStatus: {
      active: "Active",
      expiringSoon: "Expiring soon",
      expired: "Expired",
    },
    notifications: {
      newPriceList: "New price list: {{count}} offers",
      pricesUpdated: "Prices updated",
      pricesUpdatedFor: "Prices updated — {{organization}}",
      offerCount: "{{count}} offer",
      offerCount_other: "{{count}} offers",
      date: "Date: {{date}}",
      region: "Region: {{region}}",
    },
    cart: {
      title: "Cart",
      description: "Medicines in your cart",
      defaultItemLabel: "Item",
      clearCart: "Clear cart",
      clearConfirm: {
        title: "Clear cart?",
        description: "All items will be removed from your cart. This action cannot be undone.",
      },
      cleared: "Cart cleared",
      removed: "{{name}} removed from cart",
      added: "{{name}} added to cart",
      inCartTooltip: "Added to cart",
      batchAdded: "{{count}} medicines added to cart",
      medicineName: "Medicine",
      supplier: "Supplier",
      manufacturer: "Manufacturer",
      quantity: "Quantity",
      price: "Price",
      total: "Total",
      itemCount: "{{count}} medicines",
      totalAmount: "Total amount",
      beforeDiscount: "Before discount",
      youSaved: "You saved",
      priceReason: {
        title: {
          promo: "Promotional discount",
          combo: "Combo deal",
          priceDropped: "Supplier lowered the price",
          priceIncreased: "Supplier raised the price",
        },
        priceDroppedFromTo: "Was {{from}}, now {{to}}",
        priceIncreasedFromTo: "Was {{from}}, now {{to}}",
        comboEffectiveUnit: "Effective per-unit price: {{price}}",
        comboFreeUnits_one: "{{count}} free unit included in this line",
        comboFreeUnits_other: "{{count}} free units included in this line",
        totalsBreakdownTitle: "How you saved",
        totalsBreakdownReason: {
          promo: "promo",
          combo: "combo {{buy}}+{{bonus}}",
          priceDropped: "price drop",
        },
        totalsBreakdownLineSaved: "saved {{amount}}",
      },
      compactPrices: "Display prices in millions (1,000,000 → 1m)",
      expiryDate: "Expiry: {{date}}",
      issueDate: "Issued: {{date}}",
      promo: {
        suggestionsTitle: "Free items available",
        bumpQuantity: "Add {{delta}} more {{name}} to unlock {{bonus}} free",
        bumpForCrossBonus: "Add {{delta}} more {{name}} to unlock {{bonusQuantity}} free {{bonusName}}",
        bumpAction: "Increase quantity",
        addBonus: "You qualify for {{bonus}} free {{name}}",
        addBonusAction: "Add to cart",
        dismiss: "Dismiss",
        openButton: "Promotions",
        modalTitle: "Promotions in your cart",
        modalDescription: "Track progress toward each free-item bonus",
        noPromos: "No promotions match the medicines in your cart.",
        selfBonusFormula: "Buy {{buy}}, get {{bonus}} free of the same medicine",
        crossBonusFormula: "Buy {{buy}} {{name}}, get {{bonus}} free {{bonusName}}",
        bonusItemFallback: "bonus item",
        progressInCart: "{{count}} in cart",
        bonusUnlocked_one: "{{count}} free unlocked",
        bonusUnlocked_other: "{{count}} free unlocked",
        bonusClaimed: "Bonus already in cart",
        unitsToUnlockSelf_one: "Add 1 more to unlock {{bonus}} free",
        unitsToUnlockSelf_other: "Add {{count}} more to unlock {{bonus}} free",
        unitsToUnlockCross_one: "Add 1 more to unlock {{bonus}} free {{bonusName}}",
        unitsToUnlockCross_other: "Add {{count}} more to unlock {{bonus}} free {{bonusName}}",
      },
      combo: {
        bonus: "Bonus",
        bonusCount_one: "+{{count}}",
        bonusCount_other: "+{{count}}",
      },
      swap: {
        title: "Replace supplier",
        cheaperAvailable: "Cheaper offer available",
        description: "Choose a different supplier for {{name}}",
        cheaper: "Cheaper −{{percent}}%",
        moreExpensive: "More expensive +{{percent}}%",
        same: "same price",
        replace: "Replace",
        empty: "No alternative suppliers or analogues found",
        replaced: "Supplier replaced with {{name}}",
        replacedAnalogue: "Replaced with {{medicine}} from {{name}}",
        currentLabel: "Current",
        analogueLabel: "Analogue",
        bestPrice: "Best price",
        save: "Save {{amount}}",
        onlyCheaper: "Only cheaper",
      },
      empty: {
        title: "Cart is empty",
        description: "Add medicines from the search page",
        goToMedicines: "Go to medicines",
      },
      autoSelection: {
        choose: "Your cart has {{activeCount}} items. Replace it or merge {{recommendationCount}} recommendations.",
        merge: "Merge",
        replace: "Replace cart",
        unpriced_one: "{{count}} item needs a supplier.",
        unpriced_other: "{{count}} items need a supplier.",
      },
      optimize: {
        title: "Optimize prices",
        description: "Find the best prices for medicines in your cart",
        cheapest: {
          title: "Cheapest prices",
          description: "Lowest price for each medicine",
          issueDate: "Date",
          notFound: "No offers found for {{count}} medicines",
          empty: "No offers found",
          applyAll: "Apply all",
          applied: "Cheapest prices applied",
        },
        maximumTotal: "Maximum order total (UZS)",
        maximumTotalDescription: "Set a purchase cap, then recalculate every plan using the reduced quantities.",
        setMaximumTotal: "Set maximum order total",
        unlimited: "Unlimited",
        recalculate: "Recalculate plans",
        combinations: {
          title: "Pharmacy combinations",
          description: "Options to buy from fewer pharmacies",
          option: "Option {{index}}",
          suppliers: "{{count}} pharmacies",
          extraCost: "+{{amount}} extra",
          usePlan: "Select",
          applied: "Option applied",
          empty: "No combinations found",
          requiresMoreOrgs: "Best plans need more than {{count}} pharmacies; results below are partial.",
          earliestExpiry: "Earliest expiry: {{date}}",
          missingExpiry: "{{count}} items missing expiry",
          bestBy: {
            price: "Best by price",
            organization_count: "Fewest pharmacies",
            expiry: "Best by expiry",
          },
        },
        mode: {
          label: "Optimize by",
          price: "Price",
          organization_count: "Pharmacies",
          expiry: "Expiry",
          all: "All",
        },
        backToCart: "Back to cart",
        error: "An error occurred",
      },
      analyze: {
        title: "Price analysis",
        description: "Compare your cart prices against market data",
        backToCart: "Back to cart",
        cartPrice: "Cart price",
        marketMin: "Market min",
        recommended: "Recommended",
        referentWholesale: "Referent (wholesale)",
        referentRetail: "Referent (retail)",
        vsMedian: "vs Median",
        offers: "Offers",
        aboveMedian: "+{{percent}}% ▲",
        belowMedian: "−{{percent}}% ▼",
        atMedian: "0%",
        notSet: "Not set",
        noData: "No market data available",
        limitedData: "Limited market data",
        good: "Good price",
        warning: "High price",
      },
      stale: {
        banner: {
          title: "Some items are out of date",
          description_one: "{{count}} item needs to be refreshed before checkout.",
          description_other: "{{count}} items need to be refreshed before checkout.",
        },
        refreshSelected: "Refresh selected",
        refreshAll: "Refresh all stale",
        refreshing: "Refreshing…",
        selectAll: "Select all stale items",
        reason: {
          price_changed: "Price changed: {{from}} → {{to}}",
          issue_date_changed: "Issue date changed: {{from}} → {{to}}",
          price_list_file_changed: "Source price list updated ({{date}})",
          price_list_file_changed_no_date: "Source price list updated",
          offer_removed: "Offer no longer available — remove or replace this item",
          no_offer_data: "No current offer data — remove or replace this item",
          stale: "Item data is out of date",
        },
        outcome: {
          summary: "{{updated}} updated, {{unchanged}} unchanged, {{unresolved}} unresolved",
          allUpdated: "All selected items updated",
          unresolved: "Couldn't refresh — offer gone; remove or replace these items",
        },
      },
      priceChangeWarning: {
        title: "Prices have changed",
        description_one:
          "{{count}} item has a different price than what you saw. Review the changes before placing the order.",
        description_other:
          "{{count}} items have different prices than what you saw. Review the changes before placing the order.",
        unavailableTitle: "Offers are no longer available",
        unavailableDescription_one:
          "{{count}} item has an offer that no longer exists. Remove or replace it before checkout.",
        unavailableDescription_other:
          "{{count}} items have offers that no longer exist. Remove or replace them before checkout.",
        unavailable: "No longer available — remove or replace this item",
        continue: "Continue with new prices",
      },
    },
    checkout: {
      button: "Checkout",
      title: "Confirm Order",
      description: "Review and confirm your order",
      confirm: "Place Order",
      cancel: "Cancel",
      notes: "Notes (optional)",
      notesPlaceholder: "Add any notes for your order...",
      warning: "All items need a supplier, price, and issue date before checkout.",
      success: "Order created successfully",
      incompleteItems: "Some cart items are missing required data.",
      staleItems: "Some cart items are out of date. Refresh them before checking out.",
      staleWarning: "Items below are out of date — refresh them from the cart page before checking out.",
    },
    orders: {
      title: "Orders",
      description: "Your order history",
      downloadFormats: {
        excel: "Excel",
        excelZip: "Excel (ZIP)",
        pdf: "PDF",
      },
      order: "Order",
      orderId: "Order ID",
      date: "Date",
      statusLabel: "Status",
      suppliers: "Suppliers",
      totalPrice: "Total",
      grandTotal: "Grand Total",
      subtotal: "Subtotal",
      notes: "Notes",
      medicine: "Medicine",
      vendor: "Manufacturer",
      quantity: "Qty",
      unitPrice: "Price",
      lineTotal: "Total",
      download: "Download",
      expiry: "Expiry: {{date}}",
      issued: "Issued: {{date}}",
      itemCount: "{{count}} items",
      backToOrders: "Back to orders",
      notFound: "Order not found",
      notFoundDescription: "The order you're looking for doesn't exist or was removed.",
      pageInfo: "Page {{page}} of {{total}}",
      status: {
        pending: "Pending",
        confirmed: "Confirmed",
        partially_fulfilled: "Partially Fulfilled",
        fulfilled: "Fulfilled",
        cancelled: "Cancelled",
      },
      subOrderStatus: {
        pending: "Pending",
        confirmed: "Confirmed",
        shipped: "Shipped",
        delivered: "Delivered",
        cancelled: "Cancelled",
      },
      empty: {
        title: "No orders yet",
        description: "Your orders will appear here after checkout",
        goToCart: "Go to cart",
      },
      reorder: {
        action: "Order again",
        confirmTitle: "Replace current cart?",
        confirmDescription: "This will clear your current cart and add items from this order.",
        cancel: "Cancel",
        confirmAction: "Replace cart",
        pending: "Replacing...",
      },
    },
    orderImport: {
      title: "Import order files",
      description:
        "Drop one or more order .xlsx files (downloaded from the Orders page). We aggregate medicines, pick the cheapest supplier per item, and account for promotions.",
      dropHint: "Drop xlsx files here",
      fileTypes: "Supported: .xlsx, .xls — up to 20 files",
      browse: "Choose files",
      remove: "Remove file",
      generate_one: "Generate optimized cart from {{count}} file",
      generate_other: "Generate optimized cart from {{count}} files",
      success_one: "Imported. {{count}} medicine matched.",
      success_other: "Imported. {{count}} medicines matched.",
      error: "Could not import orders",
      goToOrderImport: "Import orders",
      goToPriceImport: "Import price lists",
      tabs: {
        priceLists: "Price lists",
        orders: "Orders",
      },
    },
    orderSheet: {
      backToImport: "Back to import",
      searchPlaceholder: "Search a medicine to add a live offer",
      searchHint: "Start typing a medicine name to search live wholesale offers.",
      searching: "Searching...",
      noResults: "No matching offers.",
      title: "Optimized order",
      importedTotal: "Imported total",
      optimizedTotal: "Optimized total",
      savingsVsImported: "Savings vs. imported",
      promoSavings: "Promo savings",
      estimatedTotal: "Estimated purchase total",
      pricedSubtotal: "Priced subtotal",
      medicineCount: "Medicines",
      supplierCount: "Suppliers",
      unavailableOffers: "Offers to review",
      noSupplierOffer: "No supplier offer",
      missingOffersHint: "{{count}} medicines still need an offer",
      missingOffersTitle: "{{count}} medicines have no supplier offer",
      missingOffersDescription:
        "Choose an exact medicine or analogue offer, or remove the row. Create order and XLSX stay disabled so medicines are not silently omitted.",
      budgetMaximum: "Maximum {{amount}}",
      budgetExceededTitle: "Order exceeds the available budget",
      budgetExceededDescription:
        "Current total is {{total}}; the maximum is {{maximum}}. Reduce quantities or choose cheaper suppliers before checkout or export.",
      allAbc: "All ABC",
      allXyz: "All XYZ",
      changeSupplier: "Change supplier",
      changeSupplierTooltip: "Choose an exact medicine or analogue supplier offer",
      supplierChanged: "Supplier updated",
      supplierChangeFailed: "Could not change supplier",
      selectedOfferUnavailable: "This selected offer is no longer available. Choose another supplier.",
      automaticBestOffer: "Automatic best offer",
      exactOffers: "Exact medicine offers",
      analogueOffers: "Analogue medicine offers",
      analogueBadge: "Analogue",
      analogueOfferNotice:
        "Analogue medicines are shown separately. Selecting one may adjust pack quantity to preserve approximately the same number of units.",
      analogueReplacement: "Replaces {{original}}",
      unlimited: "Unlimited",
      settings: {
        title: "Calculation settings",
        description: "Saved demand snapshot and ordering configuration.",
        legacyDescription: "This older draft is read-only. Create a new draft from POS to edit its calculation.",
        edit: "Edit settings",
        dialogTitle: "Edit calculation settings",
        dialogDescription: "Saving rebuilds generated rows from the snapshot captured when this draft was created.",
        history: "Sales history",
        coverage: "Coverage",
        leadTime: "Lead time",
        safety: "Safety stock",
        minimumSales: "Minimum sale days",
        maximumPacks: "Maximum packs per medicine",
        maximumTotal: "Maximum order total (UZS)",
        snapshot: "Snapshot captured",
        days: "{{count}} days",
        save: "Save and recalculate",
        recalculating: "Recalculating...",
        recalculated: "Auto-selection recalculated: {{count}} generated medicines.",
        failed: "Could not recalculate auto-selection.",
        quantityWarningTitle: "Manual quantities will be replaced",
        quantityWarningDescription: "Supplier choices, added products, and deleted exclusions stay unchanged.",
      },
      classification: {
        abc: {
          A: "ABC A: high sales-value contribution; usually the most financially important medicines.",
          B: "ABC B: medium sales-value contribution.",
          C: "ABC C: lower sales-value contribution.",
        },
        xyz: {
          X: "XYZ X: stable, predictable weekly demand.",
          Y: "XYZ Y: moderately variable weekly demand.",
          Z: "XYZ Z: irregular or highly variable weekly demand.",
        },
      },
      sort: {
        quantity: "Sort: quantity",
        abc: "Sort: ABC",
        xyz: "Sort: XYZ",
        revenue: "Sort: sales value",
        variability: "Sort: variability",
      },
      explanation: {
        open: "Explain recommended quantity",
        title: "How this quantity was calculated",
        salesDays: "Days with completed sales",
        period: "History / sale days",
        periodValue: "{{history}} / {{sales}} days",
        sales: "Completed sales",
        returns: "Completed returns",
        netDemand: "Net demand",
        dailyRate: "Average per day",
        demandDays: "Coverage + lead + safety",
        targetStock: "Target stock",
        currentStock: "Current stock",
        shortage: "Shortage",
        packSize: "Units per pack",
        initialPacks: "Initial packs",
        inbound: "Confirmed inbound packs",
        beforeMaximum: "Packs after inbound",
        maximum: "Maximum packs",
        minimumSalesDays: "Required sale days",
        generated: "Generated recommendation",
        orderBudget: "Maximum order total",
        budgetRequested: "Packs before budget",
        budgetAdjusted: "Packs after budget",
        current: "Current edited quantity",
        abcRevenue: "ABC net sales value (90 days)",
        abc: "ABC {{class}} · {{contribution}}% contribution · {{cumulative}}% cumulative",
        xyz: "XYZ {{class}} · weekly average {{average}} · {{variation}}% variability across {{weeks}} weeks",
        xyzInsufficient: "XYZ: not enough sales history",
      },
      supplierTotalRow: "{{count}} items · {{total}}",
      itemColumns: {
        medicine: "Medicine",
        supplier: "Supplier",
        vendor: "Supplier / manufacturer",
        quantity: "Qty",
        importedPrice: "Imported price",
        selectedPrice: "Price",
        lineTotal: "Total",
        lineSavings: "Line savings",
        expiry: "Expiry",
        issueDate: "Issue date",
        actions: "",
      },
      addProduct: "Add product",
      addProductDialogTitle: "Find a medicine to add",
      createOrder: "Create order",
      createOrderPending: "Creating...",
      createOrderSuccess: "Order created",
      removeRow: "Remove",
      removeRowSuccess: "Removed from sheet",
      addRowSuccess: "Added to sheet",
      decreaseQty: "Decrease quantity",
      increaseQty: "Increase quantity",
      promoBadge: "Promo",
      unresolvedTitle: "Could not match",
      unresolvedDescription:
        "We couldn't auto-match these rows to a medicine. Fix the source xlsx (raw name / vendor) and re-import.",
      unresolvedRow: "{{name}} · qty {{qty}} · from {{files}}",
      noOptimization: "Optimization is not available for this sheet.",
      autoSelectionTitle: "Auto-selection draft",
      autoSelectionClaiming: "Checking pharmacy access and opening the editable order...",
      autoSelectionClaimError: "This link expired, belongs to another pharmacy, or requires an organization admin.",
      autoSelectionAuthError: "Sign in as an owner or administrator of this pharmacy to open the draft.",
      autoSelectionRetry: "Try again",
      autoSelectionSignIn: "Sign in with another account",
      autoSelectionReason:
        "Sold {{sold}} units in {{days}} days · stock {{stock}} · committed inbound {{inbound}} packs",
    },
    priceListFiles: {
      backToImport: "Back to home",
      issue: "Issue",
      rows: "Rows",
      status: "Status",
      itemsTitle: "Price list items",
      itemsSearchHint: "Search rows",
      searchPlaceholder: "Search by name, code, or supplier...",
      empty: "No rows for this file.",
      cols: {
        name: "Name",
        price: "Price",
        markup: "Markup",
        paymentPercentage: "Payment percentage",
        expiry: "Expiry",
        vendor: "Supplier",
      },
    },
    overview: {
      loadFailed: "Failed to load analytics overview",
      kpi: {
        medicines: "Medicines",
        medicinesDescription: "In the market catalog",
        pharmacies: "Pharmacies",
        pharmaciesDescription: "With retail price data",
        approvedWholesalers: "Approved Wholesalers",
        wholesalersActive: "{{count}} active",
        wholesalersActiveDescription: "With live wholesale offers",
        liveWholesaleOffers: "Live Wholesale Offers",
        promotional: "{{count}} promotional",
        liveWholesaleOffersDescription: "Currently active in the market",
      },
      retail: {
        title: "Retail Coverage",
        snapshotLabel: "Medicines with price snapshot",
        snapshotHelp: "{{rate}}% of catalog has current retail prices",
        deliveryLabel: "Delivery-enabled pharmacies",
        ofCount: "of {{count}}",
        lastCrawl: "Last retail crawl:",
        never: "Never",
      },
      wholesale: {
        title: "Wholesale Coverage",
        liveOffersLabel: "Medicines with live offers",
        liveOffersHelp: "{{rate}}% of catalog has active wholesale offers",
        activeWholesalers: "Active wholesalers",
        offersWithExpiry: "Offers with expiry date",
        expiringWithin90: "Expiring within 90 days",
        soon: "Soon",
        lastCrawl: "Wholesale offers last crawled:",
        latestOfferIssue: "Latest offer issue date:",
        latestPriceListDate: "Latest price list date:",
      },
      activity: {
        title: "30-Day Activity",
        description: "Supplier updates, active wholesalers, and offer volumes over the last 30 days",
        emptyDescription: "No activity data available for the last 30 days.",
        supplierUpdates: "Supplier Updates",
        activeWholesalers: "Active Wholesalers",
        wholesaleOffers: "Wholesale Offers",
        promotionalOffers: "Promotional Offers",
      },
      clickhouse: {
        title: "Analytics History (ClickHouse)",
        statuses: {
          available: "Available",
          partial: "Partial",
          unavailable: "Unavailable",
        },
        unavailableMessage: "Analytics history data is temporarily unavailable — live market data above is unaffected.",
        partialMessage: "History coverage is incomplete. Some date ranges may be missing.",
        retailHistory: "Retail price history",
        wholesaleHistory: "Wholesale offer history",
        noHistory: "No history ranges available.",
        records: "{{count}} records",
        noData: "No data",
      },
    },
  },
} as const;
